module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0155.jpg?v=61e37c18";